export function TelemetryBanner({ message = 'Span data is temporarily unavailable; try again later.' }: { message?: string }) {
  return (
    <div role="status" className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
      Telemetry unavailable. {message}
    </div>
  )
}
